

export default {

    data() {
        return {
            destinations: [],
            masterProfiles: [],
        }
    },

    async fetch() {
        this.getData()
    },

    methods: {

        async getData() {

            if(this.visible === false) {
                return
            }

            try {

                let resultMaster = false

                let resultDestinations = this.$store.dispatch('profile/GET_DESTINATIONS', this.company.id)
                let resultSelectData = this.$store.dispatch('profile/GET_CONTACT_SELECT_DATA', this.company.id)

                if(this.company.isMasterProfile) {
                    resultMaster = this.$store.dispatch('profile/GET_MASTER_PROFILES', this.company.id)
                }

                let responseDestinations = await resultDestinations
                let responseSelectData = await resultSelectData

                this.destinations = responseDestinations.data

                if(resultMaster) {
                    let responseMaster = await resultMaster
                    this.masterProfiles = responseMaster.data
                }

            } catch (e) {
                this.$logger.captureException(e)
            }

            this.isReady = true
        }

    }

}

